import type { CourseModule } from "@/core/types";
import { lektionVorlagen } from "./lektion-01-vorlagen";
import { lektionCorporateDesign } from "./lektion-02-corporate-design";

export const modulVorlagen: CourseModule = {
  id: "vorlagen",
  title: "Vorlagen und Corporate Design",
  summary:
    "Präsentationsvorlagen (.potx) mit vollständigen Layouts, Hausfarben und " +
    "Hausschriften im Design – und wie beides im Team gepflegt wird.",
  level: "Aufbau",
  lessons: [lektionVorlagen, lektionCorporateDesign],
};
